import { apiObjUrl } from "./apiUrl";
import { rest } from "./rest";
import { Strategy } from "./Strategy";

/* eslint-disable class-methods-use-this */

const makeUrl = (key: string) => apiObjUrl(`/user-preferences/${key}`);

export class ConfigManager<T> {
  constructor(readonly strategy: Strategy<T>) {}

  async get(key: string): Promise<T> {
    const { data } = await rest.get(makeUrl(key));
    if (typeof data === "string" && !data) {
      this.strategy.bind(undefined);
      return this.strategy.execute();
    }
    this.strategy.bind(data);
    return this.strategy.execute();
  }

  async save(key: string, data: T): Promise<void> {
    await rest.post(makeUrl(key), data);
  }

  async delete(key: string): Promise<void> {
    await rest.delete(makeUrl(key));
  }
}
